import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';

@Injectable()
export class PharmacyNameMappingsService extends ApiService {
  constructor(private http: HttpClient) {
    super();
  }

  getDistinctNames(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.captureApi.url}/pharmacy_name_mappings/names`);
  }
}
